import { Enum } from "../../types/types";

export const LoginPageLocators = Enum(
  "login_button_ban_ok",
  "login_input_email",
  "login_input_password",
  "link_forgotPassword",
  "login_button_submit",
  "login_button_social_auth",
  "link_register",
  "link_login"
);
export type LoginPageLocators = Enum<typeof LoginPageLocators>;
